export default __webpack_public_path__ + "static/media/bg_desc_small_style.432128ac.jpg";